import React from 'react';
import { Table } from '@adc/parallax-component-library';

type DateCellRendererProps = {
  value: number;
  cellKey?: string | number;
};

/**
 * Renders a date cell in a table, displaying the date in a localized string format.
 * If the value is absent (0, null, undefined, etc.), it displays an empty cell.
 * @param {number} value - The timestamp value to be displayed, provided as a number.
 * @param {string | number} cellKey - Optional key for the cell.
 * @returns {React.JSX.Element}
 */
export default function DateCellRenderer({ value }: DateCellRendererProps) {
  return (
    <Table.TextCell>
      {value ? new Date(value).toLocaleString() : ''}
    </Table.TextCell>
  );
}
